import { OfferStatusIdType } from '../../constants/StatusMap';
import { RunningContractStatusType } from '../utils/searchedValues.types';

export interface DashboardSearchFieldsForm {
  salesPerson?: string;
  financialProduct?: string;
  statusId?: string | OfferStatusIdType[];
  creationDate?: string;
  searchQuery?: string;
  runningContractStatus?: RunningContractStatusType;
}

export const getFormInitialValues = (
  savedData: DashboardSearchFieldsForm,
  defaultSalesPerson?: string
): DashboardSearchFieldsForm => {
  return {
    salesPerson: savedData.salesPerson ?? defaultSalesPerson,
    financialProduct: savedData.financialProduct,
    statusId: savedData.statusId,
    creationDate: savedData.creationDate,
    searchQuery: savedData.searchQuery,
    runningContractStatus: savedData.runningContractStatus,
  };
};
